import {initializeApp} from "firebase/app"
import {getAnalytics} from "firebase/analytics";
import {getFirestore} from "firebase/firestore"
import {getAuth} from "firebase/auth"
import { getMessaging } from "firebase/messaging";

const config = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

export function getFirebaseConfig() {
    if (!config || !config.apiKey) {
        throw new Error(`No Firebase configuration object provided.
      Add your web app's configuration object to firebase-config.js`);
    } else {
        return config;
    }
}

const app = initializeApp(getFirebaseConfig());
const db = getFirestore();
// const messaging = getMessaging(app);
getAnalytics(app);
export const messaging = getMessaging(app);

export const auth = getAuth(app);
export const firestore = db;

export default db;